import { useState } from "react";
import { AlertCircle, CheckCircle2, Lock, Eye, EyeOff } from "lucide-react";

export const AuthShell = ({ children, subtitle = "Operations Portal" }) => (
  <div
    className="min-h-screen flex items-center justify-center p-4 relative"
    style={{ backgroundImage: "url(/login-bg.png)", backgroundSize: "cover", backgroundPosition: "center" }}
  >
    <div className="absolute inset-0 bg-black/40" />
    <div className="w-full max-w-md relative z-10 px-4 sm:px-0">
      <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 sm:p-8 border border-white/20">
        <div className="flex flex-col items-center mb-6">
          <div className="w-56 h-24 sm:w-72 sm:h-32 overflow-hidden flex items-center justify-center mb-2">
            <img src="/dolphin-login-logo.png" alt="Dolphin Retail Media" className="w-full object-contain" />
          </div>
          <h1 className="text-xs font-bold tracking-[0.2em] text-[#006994] mt-1">DOLPHIN VENUE VISION</h1>
          <p className="text-slate-500 text-sm mt-2">{subtitle}</p>
        </div>
        {children}
        <div className="mt-6 pt-4 border-t border-slate-100 flex flex-col items-center">
          <p className="text-xs text-slate-400">Dolphin Digital OOH Media &copy; {new Date().getFullYear()}</p>
        </div>
      </div>
    </div>
  </div>
);

export const AuthAlert = ({ type = "error", children, testId }) => {
  const ok = type === "success";
  const Icon = ok ? CheckCircle2 : AlertCircle;
  return (
    <div
      data-testid={testId}
      className={`mb-4 p-3 rounded-xl flex items-start gap-3 border ${ok ? "bg-emerald-50 border-emerald-200" : "bg-red-50 border-red-200"}`}
    >
      <Icon className={`w-5 h-5 mt-0.5 flex-shrink-0 ${ok ? "text-emerald-500" : "text-red-500"}`} />
      <p className={`text-sm ${ok ? "text-emerald-700" : "text-red-600"}`}>{children}</p>
    </div>
  );
};

export const PasswordField = ({ label, value, onChange, placeholder, testId, autoComplete }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <label className="text-xs font-medium text-slate-500 mb-1.5 block">{label}</label>
      <div className="relative">
        <Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required
          data-testid={testId}
          className="w-full pl-10 pr-10 py-3 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#006994]/20 focus:border-[#006994]"
        />
        <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2" data-testid={`${testId}-toggle`}>
          {show ? <EyeOff className="w-4 h-4 text-slate-400" /> : <Eye className="w-4 h-4 text-slate-400" />}
        </button>
      </div>
    </div>
  );
};

export const validateNewPassword = (pw, confirm) => {
  if (pw.length < 8) return "Password must be at least 8 characters";
  if (pw !== confirm) return "Passwords do not match";
  return "";
};
